<template>
			<div class="guidance-wrapper">
				<div class="title">
					<div class="text"><h3>- 診断結果に関して -</h3>
						<h2>自分自身の外向性を<br>
							より良く活かした<br>
							人生のリスタートを</h2>
						<p class="en">Guidance your Extrovert</p>
					</div>
					<img src="../assets/result-index-guidance.svg" alt="*">
				</div>
				<div class="sentence">
					<div  v-if="levelResult.percentage < 50 && levelResult.percentage >= 35" class="branch">
						<div class="type">
							<span>Your Intorvet</span>Medium Type
						</div><!-- end .type -->
						<h2>内向性と外向性のバランスを取って、質の高いオールラウンダーを目指すことができる弱外向型</h2>
						<p>本診断であなたの内向度は{{levelResult.percentage}}%となりました。あなたの内向度はやや低く、あなたは現状では外向型の気質を持った人間と言えるでしょう。イベントや旅行など、思考や行動は比較的に外へ向いていることが多いと言えます。ただし、外向度が「とても強い」というレベルではなく、内向的な感度もあなたは持っています。</p>
						<p>外向的に動きながら、内向的に考える、こんな出来事がとても向いているとも言えます。内向性と外向性のバランスが取れた人間の最大の魅力は、どの場面でもそつなく過ごせることにあるでしょう。</p>
						<p>外向的なスキルと内向的な思考力の両方を高めていけば、あなたはより最強のオールラウンダーになります。今の自分を認めてあげながらも、自己成長を重ねていけば、より多大な幸福と成功を手にできるでしょう。</p>
						<p>内向性と外向性を平均的に持っていて、なおかつ外向性が強いあなたの場合は、自己対話よりも、他者との対話で、他者の内面を常に考えることをしていくと、内向的な思考力は高まりやすくなるでしょう。レベルが高いところで、内向性と外向性のバランスが取れる人間は、組織の中にいても、個人で活動しても、上手くいきやすく、人生の選択肢がどんどん増えていきます。</p>
					</div><!-- end .branch -->
					<div  v-if="levelResult.percentage < 35 && levelResult.percentage >= 15" class="branch">
						<div class="type">
							<span>Your Intorvet</span>Smallish Type
						</div><!-- end .type -->
						<h2>考えるよりも先に行動、外へ動くことを反射的に選択しやすい外向型</h2>
						<p>本診断であなたの内向度は{{levelResult.percentage}}%となりました。あなたの内向度は低く、まさにあなたは外向型の人間と言えるでしょう。イベントや旅行など、外に出向くことを好み、思考や行動は外へ向いていることが多いと言えます。人に会って話す営業やいろんな場所へ出向く出張の多い仕事などでは、あなたは自分らしく清々しく過ごせるでしょう。パートナーや親友も外向性の強い人を選ぶことで、あなたは人付き合いでよりより心を満たすことができる傾向にあります。</p>
						<p>内向的な成功例や内向度が強い人の手法を参考にすると苦しむ可能性もあります。外向度が反射的に強いということは、それだけ内向性を深める機会を避けることを意味します。もしも、あなたが内向的になりたいのであれば、一時的には大きなストレス下にさらされるでしょう。外向的な人が少しでも内向性を高めることはとてもいいことです。</p>
						<p>内向性と外向性をバランスよく持つ人間はとても重宝されます。また、また、あなたのようなタイプが内向型を少しでも積み上げれば、ポップカルチャーなど、大衆的なアウトプットの場で価値のあるコンテンツを提供できるようになります。テレビのバラエティタレントなど、一般向けに分かりやすく何かを披露したり、伝えたりする仕事で活躍が期待できます。B to Cのコミュニケーションが必要な職業で幅広い人に対応するためには、今の外向性に内向性を戦略的に上乗せしても良いでしょう。</p>	
					</div><!-- end .branch -->
					<div v-if="levelResult.percentage < 15 && levelResult.percentage >= 0" class="branch">
						<div class="type">
							<span>Your Intorvet</span>Minuscule Type
						</div><!-- end .type -->
						<h2>行動の瞬発性に優れ、外への欲求をエネルギーに昇華させることが得意な極度の外向型</h2>
						<p>本診断であなたの内向度は{{levelResult.percentage}}%となりました。あなたの内向度は非常に低く、まさにあなたは外向型の人間と言えるでしょう。{{levelResult.percentage}}%の数字がゼロに近づけば近づくほど、内向的な行動を度外視し、まずは外向きな動きを示す体質が強いと言えます。</p>
						<p>外向度は後天的に身に着けることは非常に難しいと言えます。もちろん、極度の外向的な人のようなパフォーマンスを取ることは可能のですが、他のタイプがそのように振舞うスキルを身に着けても、メンタルの非常に素早く疲弊します。あなたが自然と取っている行動は、他のタイプからすれば、とても精神力や体力が必要なことなのです。このタイプは、内省が苦手なので、反省に時間を取るくらいなら、どんどん手を打っていくほうが得策です。人に救われ、人の縁で、人生を好転させるタイプです。ただし、内向的な人や内向度が極端に強い人とは話が合わないと感じたり、一緒にいて楽しくないと感じることもあるでしょう。そうした人には、まったく違う存在だからこそ、そもそも分かり合えないし、だからこそ、一緒にいて食い違うことがむしろ面白いと思ってもらえると、真逆のタイプの人も上手に取り込んでしまうことができます。</p>				
					</div><!-- end .branch -->	
					<img src="../assets/result-index-img01.svg" alt="*" />
					<div class="caption">
						あなたは外向型にフィットさせた行動を取ることでより自分らしく人生を成功に導ける
					</div><!-- end .caption -->
					<p>ただし、これは、あくまでも潜在能力に過ぎません。潜在能力を開花させ、実質的に世の中で活躍するためには、あらゆる場面で外向的スキルが求められます。そのため、あなたが自分自身の外向的特性にフィットしたマインドやスキルを積み上げていなければ、人生の多くのシーンでかなりの息苦しさを感じることになります。</p>
					<p>自分の適性とは、何も積み上げなければ、ただの潜在能力で終わります。潜在能力を引き出し、実力として世界に轟かせるには、その適性を生かすマインドやスキルを後天的に身に付けていく必要があるのです。</p>
					<p>既に満足いく結果を出し続けているのであれば、あなたは自身の外向的タイプにぴったりの人生をセルフプロデュースしていると言えるでしょう。自分に合った思考・マインド・努力・情報収取を続けて、確実に経験を増やせば、恋愛でも仕事でも「狙って結果を出す」ことができるのです。</p>
					<h3>自分の内向度を「大きな武器」にするために必要な3つの要素</h3>
					<p>内向度{{ levelResult.percentage }}%のあなたが、その才能を大いに発揮し、あらゆるシチュエーションで「狙って結果を出す」ためには、(1)マインドセット、(2)コミュニケーションスキル、(3)アウトプットスキルの3つを、あなたの内向的特性に合わせて磨く必要があります。</p>
					<img src="../assets/result-index-img02.svg" alt="*" />
					<div class="caption">
						内向性の強弱が、どんなマインドやスキルと組み合わせるかで、人生の良し悪しは雲泥の差になるのだ。
					</div><!-- end .caption -->
					<p>今回の診断では、あなたが自身の内向性をより活かすための(1)マインドセット、(2)コミュニケーションスキル、(3)アウトプットスキルについて網羅しています。</p>
					<p>私たちは、あなたらしさを生かした人生がよりキラキラと磨かれ、自身の最大限の幸福だけでなく、その幸福が家族や友人や他人の幸福までもを巻き込んでいくことを、心より願っています。</p>
					<h4>さぁ、あなたの人生を輝かせる<br class="sp-disblock">新しい術と道を見つけよう！</h4>
					<router-link class="next" to="/result-detail">診断結果の詳細へ</router-link>
					<h5>次のページで、さらに詳細な診断結果を<br class="sp-disblock">閲覧することができます！</h5>
				</div><!-- end .sentence -->
			</div><!-- end .guidance-wrapper -->			
</template>

<script>


export default {
	name: 'ResultIndexLevelOutrovert',
	components: {

	},
	
	data: function () {
		return {
		}
	},
	methods:{
		pageTop:function(){
			window.scrollBy({
			top: 150,
			behavior: 'smooth'
			});
		}
	},
	props:[

	],
	computed: {
		levelResult:function(){
			return this.$store.getters.levelResult
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
